import {
  LEF_WAIVER_SECURED_MAX_IR,
  LEF_WAIVER_SECURED_MIN_IR,
  LEF_WAIVER_UNSECURED_COMPARISON_MAX_IR,
  LEF_WAIVER_UNSECURED_COMPARISON_MIN_IR,
  PL_SECURED_COMPARISON_MAX_IR,
  PL_SECURED_COMPARISON_MIN_IR,
  PL_SECURED_MAX_IR,
  PL_SECURED_MIN_IR,
  PL_SYMPLE_SECURED_COMPARISON_MAX_IR,
  PL_SYMPLE_SECURED_COMPARISON_MIN_IR,
  PL_SYMPLE_SECURED_MAX_IR,
  PL_SYMPLE_SECURED_MIN_IR,
  PL_SYMPLE_UNSECURED_COMPARISON_MAX_IR,
  PL_SYMPLE_UNSECURED_COMPARISON_MIN_IR,
  PL_SYMPLE_UNSECURED_MAX_IR,
  PL_SYMPLE_UNSECURED_MIN_IR,
  PL_UNSECURED_COMPARISION_MIN_IR,
  PL_UNSECURED_COMPARISON_MAX_IR,
  PL_UNSECURED_MAX_IR,
  PL_UNSECURED_MIN_IR
} from '../../utils/constants';

export const FINDER_RATE_OVERRIDES = Object.freeze({
  secured: Object.freeze({
    minInterestRate: 7.99,
    maxInterestRate: 27.39,
    maxComparisonRate: 28.97,
    minComparisonRate: 9.68
  }),
  unsecured: Object.freeze({
    minInterestRate: 7.99,
    maxInterestRate: 27.39,
    maxComparisonRate: 28.97,
    minComparisonRate: 9.68
  })
});

export function getRateBounds({
  loans1,
  isVariable,
  isFinder,
  isLefWaiver
}) {
  if (loans1) {
    if (isVariable) {
      if (isFinder) {
        return {
          minInterestRate: FINDER_RATE_OVERRIDES.secured.minInterestRate,
          maxInterestRate: FINDER_RATE_OVERRIDES.secured.maxInterestRate,
          maxComparisonRate: isLefWaiver
            ? LEF_WAIVER_SECURED_MAX_IR
            : FINDER_RATE_OVERRIDES.secured.maxComparisonRate,
          minComparisonRate: isLefWaiver
            ? LEF_WAIVER_SECURED_MIN_IR
            : FINDER_RATE_OVERRIDES.secured.minComparisonRate
        };
      }

      return {
        minInterestRate: PL_SYMPLE_SECURED_MIN_IR,
        maxInterestRate: PL_SYMPLE_SECURED_MAX_IR,
        maxComparisonRate: isLefWaiver
          ? LEF_WAIVER_SECURED_MAX_IR
          : PL_SYMPLE_SECURED_COMPARISON_MAX_IR,
        minComparisonRate: isLefWaiver
          ? LEF_WAIVER_SECURED_MIN_IR
          : PL_SYMPLE_SECURED_COMPARISON_MIN_IR
      };
    }

    if (isFinder) {
      return {
        minInterestRate: FINDER_RATE_OVERRIDES.unsecured.minInterestRate,
        maxInterestRate: FINDER_RATE_OVERRIDES.unsecured.maxInterestRate,
        maxComparisonRate: isLefWaiver
          ? LEF_WAIVER_UNSECURED_COMPARISON_MAX_IR
          : FINDER_RATE_OVERRIDES.unsecured.maxComparisonRate,
        minComparisonRate: isLefWaiver
          ? LEF_WAIVER_UNSECURED_COMPARISON_MIN_IR
          : FINDER_RATE_OVERRIDES.unsecured.minComparisonRate
      };
    }

    return {
      minInterestRate: PL_SYMPLE_UNSECURED_MIN_IR,
      maxInterestRate: PL_SYMPLE_UNSECURED_MAX_IR,
      maxComparisonRate: isLefWaiver
        ? LEF_WAIVER_UNSECURED_COMPARISON_MAX_IR
        : PL_SYMPLE_UNSECURED_COMPARISON_MAX_IR,
      minComparisonRate: isLefWaiver
        ? LEF_WAIVER_UNSECURED_COMPARISON_MIN_IR
        : PL_SYMPLE_UNSECURED_COMPARISON_MIN_IR
    };
  }

  if (isVariable) {
    return {
      minInterestRate: PL_SECURED_MIN_IR,
      maxInterestRate: PL_SECURED_MAX_IR,
      maxComparisonRate: PL_SECURED_COMPARISON_MAX_IR,
      minComparisonRate: PL_SECURED_COMPARISON_MIN_IR
    };
  }

  return {
    minInterestRate: PL_UNSECURED_MIN_IR,
    maxInterestRate: PL_UNSECURED_MAX_IR,
    maxComparisonRate: PL_UNSECURED_COMPARISON_MAX_IR,
    minComparisonRate: PL_UNSECURED_COMPARISION_MIN_IR
  };
}
